<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">
        {{ m.p_name }}
        <span class="glyphicon glyphicon-user pull-right"></span>
      </h3>
    </div>
    <div class="panel-body" @click="expand = !expand">
      <ul class="media-list">
        <li class="media">
          <div class="media-left">
            <img class="avatar media-object" :src="avatar_url" />
          </div>
          <div class="media-body">
            <div class="media-heading">
              <b>{{ m.p_position }}</b>
            </div>
            <div>{{ m.p_company }}</div>
            <div>
              电话:
              <a :href="'tel:' + m.p_phone">{{ m.p_phone }}</a>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <ul class="list-group" v-show="expand">
      <li class="list-group-item" v-show="m.p_email">邮箱：{{ m.p_email }}</li>
      <li class="list-group-item" v-show="m.p_qq">QQ：{{ m.p_qq }}</li>
      <li class="list-group-item" v-show="m.p_qq">
        {{ m.p_remark }}
      </li>
    </ul>

    <div class="panel-footer">
      <span class="glyphicon glyphicon-thumbs-up"></span>
      <b>主营产品：</b>
      {{ products }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["m"],
  data() {
    return { expand: false };
  },
  computed: {
    avatar_url() {
      if (this.m.avatar) {
        return this.m.avatar + "?imageView2/2/w/60/h/60/q/100";
      } else {
        return "http://ww2.sinaimg.cn/large/801b780ajw1f8zvq84qkkj2040040wek.jpg";
      }
    },
    products() {
      return this.m.main_product_ids.map((i) => i.text).join("，");
    },
  },
};
</script>

<style>
.avatar {
  width: 60px;
  height: 60px;
}
</style>
